





































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getInvitationRank } from "@/api";
import { DEFAULT_AVATAR } from "@/components/InvitedUser.vue";
@Component
export default class ActRankList extends Vue {
  @Prop({ type: Object, required: true }) info!: any;
  $refs!: {
    scroll: HTMLElement;
    scrollContent: HTMLElement;
  };
  list: Array<any> = [];
  params: any = {
    page: 0,
    limit: 10,
    loading: true
  };
  hasMore: boolean = false;
  mounted() {
    this.getList();
    console.log(this.info);
  }
  toMy() {
    this.$router.push({
      name: "myv2",
      params: { actId: this.$route.params.actId }
    });
  }
  nowRank: number = 1;
  async getList() {
    console.log("getList");
    let actId = Number(this.$route.params.actId);
    let opt = {
      page: this.params.page,
      limit: this.params.limit,
      needCount: 1
    };
    let { rows, count } = await getInvitationRank(actId, opt);
    this.hasMore = count - (opt.page + 1) * opt.limit > 0;
    this.params.page++;
    this.params.loading = false;
    if (opt.page === 0) {
      this.list = rows;
    } else {
      this.list = this.list.concat(rows);
    }
    this.list.forEach((item, index) => {
      item.rank = index + 1;
      item.avatar = item.avatar || DEFAULT_AVATAR;
      if (item.userId === this.info.userId) {
        this.nowRank = index + 1;
      }
    });
  }
  onScroll() {
    const loadHeight =
      this.$refs.scroll.offsetHeight + this.$refs.scroll.scrollTop;
    const contentHeight = this.$refs.scrollContent.offsetHeight;
    if (
      contentHeight - loadHeight <= 0 &&
      !this.params.loading &&
      this.hasMore
    ) {
      this.params.loading = true;
      this.getList();
    }
  }
}
